/*
 ============================================================
  CELESTIAL STONES – INVENTORY DATABASE (FRONTEND)
  This file controls all product data shown in Shop
  Edit only this file to manage inventory
 ============================================================
*/

export const stonesData = [

  /* =========================
     SUN (RUBY / SUNSTONE)
  ========================== */
  {
    id: "CS-001",

    name: "Natural Ruby Ring",
    planet: "Sun",
    category: "rings",

    price: 5999,
    originalPrice: 7999,

    image: "/img/ruby-ring.jpg",
    emoji: "☀️",

    rating: 4.8,
    reviews: 124,

    inStock: true,

    tags: ["Bestseller"],

    description:
      "Certified natural ruby ring to enhance confidence, leadership, and vitality."
  },

  {
    id: "CS-002",

    name: "Sunstone Pendant",
    planet: "Sun",
    category: "pendants",

    price: 3499,
    originalPrice: 4999,

    image: "/img/sunstone-pendant.jpg",
    emoji: "🌟",

    rating: 4.6,
    reviews: 89,

    inStock: true,

    tags: ["New"],

    description:
      "Pure sunstone pendant for positive energy, success, and self-belief."
  },


  /* =========================
     MOON (PEARL)
  ========================== */
  {
    id: "CS-003",

    name: "Freshwater Pearl Bracelet",
    planet: "Moon",
    category: "bracelets",

    price: 3299,
    originalPrice: 4599,

    image: "/img/pearl-bracelet.jpg",
    emoji: "🌙",

    rating: 4.7,
    reviews: 102,

    inStock: true,

    tags: ["Premium"],

    description:
      "Natural pearl bracelet for emotional balance, peace, and mental clarity."
  },

  {
    id: "CS-004",

    name: "Pearl Ring in Silver",
    planet: "Moon",
    category: "rings",

    price: 2899,
    originalPrice: 3999,

    image: "/img/pearl-ring.jpg",
    emoji: "🤍",

    rating: 4.5,
    reviews: 67,

    inStock: true,

    tags: [],

    description:
      "Elegant pearl ring to strengthen intuition and inner calm."
  },


  /* =========================
     MARS (RED CORAL)
  ========================== */
  {
    id: "CS-005",

    name: "Red Coral Pendant",
    planet: "Mars",
    category: "pendants",

    price: 2999,
    originalPrice: 3999,

    image: "/img/red-coral.jpg",
    emoji: "🔴",

    rating: 4.6,
    reviews: 76,

    inStock: false,

    tags: [],

    description:
      "Authentic red coral pendant for courage, strength, and protection."
  },


  /* =========================
     MERCURY (EMERALD)
  ========================== */
  {
    id: "CS-006",

    name: "Emerald Ring (Panna)",
    planet: "Mercury",
    category: "rings",

    price: 8999,
    originalPrice: 12999,

    image: "/img/emerald-ring.jpg",
    emoji: "💚",

    rating: 4.9,
    reviews: 140,

    inStock: true,

    tags: ["Premium"],

    description:
      "Certified emerald ring for intelligence, business growth, and communication."
  },


  /* =========================
     JUPITER (YELLOW SAPPHIRE)
  ========================== */
  {
    id: "CS-007",

    name: "Yellow Sapphire Pendant",
    planet: "Jupiter",
    category: "pendants",

    price: 7499,
    originalPrice: 9999,

    image: "/img/yellow-sapphire.jpg",
    emoji: "🟡",

    rating: 4.7,
    reviews: 91,

    inStock: true,

    tags: ["Recommended"],

    description:
      "Natural yellow sapphire pendant for wisdom, prosperity, and success."
  },


  /* =========================
     VENUS (DIAMOND / OPAL)
  ========================== */
  {
    id: "CS-008",

    name: "Diamond Solitaire Pendant",
    planet: "Venus",
    category: "pendants",

    price: 14999,
    originalPrice: 19999,

    image: "/img/diamond-pendant.jpg",
    emoji: "💎",

    rating: 4.9,
    reviews: 210,

    inStock: true,

    tags: ["Bestseller", "Premium"],

    description:
      "Certified diamond pendant for love, luxury, and relationship harmony."
  },

  {
    id: "CS-009",

    name: "Opal Silver Ring",
    planet: "Venus",
    category: "rings",

    price: 5299,
    originalPrice: 6999,

    image: "/img/opal-ring.jpg",
    emoji: "🤍",

    rating: 4.6,
    reviews: 83,

    inStock: true,

    tags: [],

    description:
      "Natural opal ring for creativity, romance, and emotional balance."
  },


  /* =========================
     SATURN (BLUE SAPPHIRE)
  ========================== */
  {
    id: "CS-010",

    name: "Blue Sapphire Ring (Neelam)",
    planet: "Saturn",
    category: "rings",

    price: 11999,
    originalPrice: 15999,

    image: "/img/blue-sapphire.jpg",
    emoji: "🔵",

    rating: 4.8,
    reviews: 132,

    inStock: true,

    tags: ["Premium"],

    description:
      "Natural blue sapphire ring for discipline, stability, and career growth."
  }
];

export default stonesData;
